import React from "react";
import LegalStrip from "./LegalStrip";

const formatTimestamp = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "";
    const date = d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
    const time = d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
    return `Note updated ${date} · ${time}`;
  } catch (err) {
    return "";
  }
};

const AgentNote = ({ agent, note, mode, placeholderText }) => {
  const hasNote = !!(note && note.text && note.text.trim().length > 0);
  if (!hasNote && mode !== "agent") return null;

  const showPlaceholder = !hasNote && mode === "agent";

  return (
    <section
      id="agent-note"
      className="abr-section"
      aria-labelledby="abr-agent-note-title"
    >
      <div className="abr-agent-note-eyebrow" id="abr-agent-note-title">
        Strategic note from your agent
      </div>
      <div className="abr-agent-note-card">
        <img
          src={agent.photoUrl}
          alt={`${agent.fullName}, ${agent.title} at ${agent.brokerage}`}
          className="abr-agent-note-photo"
        />
        <div className="abr-agent-note-body">
          <div className="abr-agent-note-name">
            <span>{agent.fullName}</span>
            {showPlaceholder ? <span className="abr-pending-badge">Pending</span> : null}
          </div>
          <div className="abr-agent-note-attribution">
            {agent.title} &middot; <strong>{agent.brokerage}</strong>
            <br />
            {agent.licenseLabel} &middot; {agent.mlsLabel}
          </div>
          <div className={`abr-agent-note-text${showPlaceholder ? " is-placeholder" : ""}`}>
            {hasNote ? note.text : placeholderText}
          </div>
          <div className="abr-agent-note-meta">{hasNote ? formatTimestamp(note.ts) : ""}</div>
        </div>
      </div>

      <LegalStrip agent={agent} />
    </section>
  );
};

export default AgentNote;
